export default __webpack_public_path__ + "static/media/58_mobile.d9d5f20b.jpg";